import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Purchase = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M6 19.1249H15.921C16.2753 19.125 16.6182 18.9996 16.889 18.7709C17.1597 18.5423 17.3407 18.2253 17.4 17.8759L20.037 2.37593C20.0965 2.02678 20.2776 1.70994 20.5483 1.48153C20.819 1.25311 21.1618 1.12785 21.516 1.12793H22.5"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.375 21.375C15.4492 21.375 15.5217 21.397 15.5833 21.4382C15.645 21.4794 15.6931 21.538 15.7215 21.6065C15.7498 21.675 15.7573 21.7504 15.7428 21.8232C15.7283 21.8959 15.6926 21.9627 15.6402 22.0152C15.5877 22.0676 15.5209 22.1033 15.4482 22.1178C15.3754 22.1323 15.3 22.1248 15.2315 22.0965C15.163 22.0681 15.1044 22.02 15.0632 21.9583C15.022 21.8967 15 21.8242 15 21.75C15 21.6505 15.0395 21.5552 15.1098 21.4848C15.1802 21.4145 15.2755 21.375 15.375 21.375"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.37476 21.3745C8.44892 21.3745 8.52143 21.3965 8.58309 21.4377C8.64476 21.4789 8.69283 21.5375 8.72121 21.606C8.74959 21.6745 8.75702 21.7499 8.74255 21.8227C8.72808 21.8954 8.69237 21.9622 8.63992 22.0147C8.58748 22.0671 8.52066 22.1028 8.44791 22.1173C8.37517 22.1318 8.29977 22.1243 8.23125 22.096C8.16273 22.0676 8.10416 22.0195 8.06295 21.9579C8.02175 21.8962 7.99976 21.8237 7.99976 21.7495C7.99976 21.6501 8.03926 21.5547 8.10959 21.4843C8.17992 21.414 8.2753 21.3745 8.37476 21.3745"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9529 14.6251H5.88193C5.21301 14.625 4.5633 14.4014 4.03605 13.9897C3.5088 13.5781 3.13425 13.002 2.97193 12.3531L1.52193 6.55309C1.49426 6.44248 1.49218 6.32702 1.51583 6.21548C1.53949 6.10394 1.58827 5.99927 1.65846 5.90941C1.72864 5.81955 1.81839 5.74688 1.92089 5.69692C2.02338 5.64696 2.13591 5.62103 2.24993 5.62109H19.4839"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
